import { borderRadius, color, css, spacing, styled } from '@lessonup/ui-components';
import React, { ReactNode } from 'react';

type TagPadding = 'small';
type Shadow = 'none';
type Radius = 'small';

type PinTagThemeSettings = {
  padding: Record<TagPadding, string>;
  shadow: Record<Shadow, string>;
  radius: Record<Radius, string>;
  colors: {
    fill: string;
    on: string;
    stroke: string;
  };
};

export interface PinTagProps {
  children: ReactNode;
  className?: string;
  padding?: TagPadding;
  shadow?: Shadow;
  radius?: Radius;
}

/**
 * Tag component for use inside a pin.
 *
 * Styled according to theme a teacher chooses for a lesson.
 */
export const PinTag: React.FC<PinTagProps> = ({
  children,
  className,
  padding = 'small',
  shadow = 'none',
  radius = 'small',
}) => {
  const theme: PinTagThemeSettings = {
    padding: {
      small: spacing.size2,
    },
    shadow: {
      none: ``,
    },
    radius: {
      small: borderRadius.rounded4,
    },
    colors: {
      fill: color.neutralNew.surface.fill,
      on: color.neutralNew.surface.on,
      stroke: color.neutralNew.surface.stroke,
    },
  };

  return (
    <StyledPinTag className={className} padding={padding} shadow={shadow} radius={radius} theme={theme}>
      {children}
    </StyledPinTag>
  );
};

const StyledPinTag = styled.div<{
  padding: TagPadding;
  shadow: Shadow;
  radius: Radius;
  theme: PinTagThemeSettings;
}>`
  ${({ theme, radius }) => css`
    border-radius: ${theme.radius[radius]};
  `}
  ${({ theme, shadow }) => css`
    box-shadow: ${theme.shadow[shadow]};
  `}
  ${({ theme, padding }) => css`
    padding: ${theme.padding[padding]};
  `}
  ${({ theme }) => css`
    background-color: ${theme.colors.fill};
    color: ${theme.colors.on};
    border: 1px solid ${theme.colors.stroke};
  `}
`;
